import CreateFileResourceInteractor from "../../../core/interactor/app/crud/CreateFileResourceInteractor";
import Constants from "../../common/Constants";
import { IAttachment } from "../../model/Attachment";
import AttachmentMapper from "../../service/AttachmentMapper";
import AttachmentParamMapper from "../../service/AttachmentParamMapper";

export default class CreateAttachmentFileInteractor {
  private createFileResource: CreateFileResourceInteractor<IAttachment>;

  constructor({ createFileResource }: any) {
    this.createFileResource = createFileResource;
  }
  getFormValueData = (
    attachment: IAttachment,
    file: any,
    caseLawDocumentId?: number,
    caseDecisionId?: string,
    legalViewId?: number
  ) => {
    let formParams = AttachmentParamMapper(attachment);
    let formData = new FormData();
    if (file) {
      formData.append("data", file, file.name);
    }
    if (caseLawDocumentId) {
      formData.append("caseLawDocumentId", caseLawDocumentId.toString());
    }
    if (caseDecisionId) {
      formData.append("caseDecisionId", caseDecisionId);
    }
    if (legalViewId) {
      formData.append("legalViewId", legalViewId.toString());
    }
    formParams.id && formData.append("id", formParams.id.toString());
    if (formParams.attachmentTypeId) {
      formData.append(
        "attachmentTypeId",
        formParams.attachmentTypeId.toString()
      );
    }
    formParams.content &&
      formData.append("content", formParams.content.toString());
    formData.append("name", formParams.name.toString());
    formParams.description &&
      formData.append("description", formParams.description.toString());
    formData.append("valid", formParams.valid.toString());
    formData.append("anonymised", formParams.anonymised.toString());
    if (attachment.originalAttachmentId) {
      formData.append(
        "originalAttachmentId",
        attachment.originalAttachmentId.toString()
      );
    }
    return formData;
  };
  async execute(
    model: IAttachment,
    file: any,
    caseLawDocumentId?: number,
    caseDecisionId?: string,
    legalViewId?: number
  ) {
    if (caseLawDocumentId) {
      let data = this.getFormValueData(model, file, caseLawDocumentId);
      return await this.createFileResource.execute(
        `${Constants.endpointBasePath}/${caseLawDocumentId}/${Constants.attachmentPath}/file`,
        AttachmentMapper,
        file,
        data
      );
    } else if (caseDecisionId) {
      let data = this.getFormValueData(model, file, undefined, caseDecisionId);
      return await this.createFileResource.execute(
        `case-decisions/${caseDecisionId}/${Constants.attachmentPath}/file`,
        AttachmentMapper,
        file,
        data
      );
    } else if (legalViewId) {
      let data = this.getFormValueData(
        model,
        file,
        undefined,
        undefined,
        legalViewId
      );
      return await this.createFileResource.execute(
        `${Constants.legalViewPath}/${legalViewId}${Constants.attachmentPath}/file`,
        AttachmentMapper,
        file,
        data
      );
    } else {
      let data = this.getFormValueData(model, file);
      return await this.createFileResource.execute(
        `case-decisions/${Constants.attachmentPath}/files`,
        AttachmentMapper,
        file,
        data
      );
    }
  }
}
